import { z } from 'zod';
import { optionalEmailSchema, validateEmail } from '../common/email.js';
import { countryCodeSchema, phoneNumberSchema, validatePhone } from '../common/phone-number.js';
export const spouseSchema = z
    .object({
    contact_id: z.string().optional(),
    has_website_account: z.boolean().optional(),
    first_name: z.string().meta({ label: 'First Name' }).optional(),
    last_name: z.string().meta({ label: 'Last Name' }).optional(),
    email_address: optionalEmailSchema.meta({ label: 'Email' }),
    phone_mobile: z
        .string()
        .meta({ ...phoneNumberSchema.meta(), label: 'Mobile Phone' })
        .optional(),
    phone_mobile_country_code: countryCodeSchema,
})
    .meta({ field: 'spouse' })
    .superRefine((data, ctx) => {
    const hasAnySpouseData = data.first_name || data.last_name || data.email_address || data.phone_mobile;
    // An existing contact_id means the spouse is already linked in the CRM and
    // is advisor-managed (read-only on the website), so legacy incomplete CRM
    // data (e.g. a null last_name) must not block unrelated profile saves.
    if (hasAnySpouseData && !data.contact_id?.trim()) {
        if (!data.first_name)
            ctx.addIssue({ code: 'custom', path: ['first_name'], message: 'First name is required' });
        if (!data.last_name)
            ctx.addIssue({ code: 'custom', path: ['last_name'], message: 'Last name is required' });
        validatePhone(ctx, 'phone_mobile', data.phone_mobile, data.phone_mobile_country_code);
    }
});
/** Payload for POST /profile/spouse — creates a linked spouse contact in CRM. */
export const createSpouseRequestSchema = z
    .object({
    first_name: z.string().meta({ label: 'First Name' }).optional(),
    last_name: z.string().meta({ label: 'Last Name' }).optional(),
    email_address: optionalEmailSchema.meta({ label: 'Email' }),
    phone_mobile: z
        .string()
        .meta({ ...phoneNumberSchema.meta(), label: 'Mobile Phone' })
        .optional(),
    phone_mobile_country_code: countryCodeSchema,
})
    .superRefine((data, ctx) => {
    if (!data.first_name?.trim()) {
        ctx.addIssue({ code: 'custom', path: ['first_name'], message: 'First name is required' });
    }
    if (!data.last_name?.trim()) {
        ctx.addIssue({ code: 'custom', path: ['last_name'], message: 'Last name is required' });
    }
    validatePhone(ctx, 'phone_mobile', data.phone_mobile, data.phone_mobile_country_code);
});
/** RSVP spouse create — email is required to create the CRM contact. */
export const rsvpCreateSpouseRequestSchema = createSpouseRequestSchema.superRefine((data, ctx) => {
    validateEmail(ctx, 'email_address', data.email_address);
});
export function spouseNeedsCreation(spouse) {
    if (!spouse || spouse.contact_id?.trim()) {
        return false;
    }
    return !!(spouse.first_name?.trim() ||
        spouse.last_name?.trim() ||
        spouse.email_address?.trim() ||
        spouse.phone_mobile?.trim());
}
